import moment from 'moment';

export const formatDate = (date: any, isFullDate = false) => {
  if (isFullDate) {
    return moment(new Date(date)).format('DD MMM, YYYY HH:mm A');
  }
  return moment(new Date(date)).format('DD MMM, YYYY');
};

export const formatTime = (date: any) => {
  return moment(new Date(date)).format('HH:mm');
};

export const formatDay = (date: any) => {
  return moment(new Date(date)).format('dddd');
};

export const formatDatePayload = (date: any) => {
  return moment(new Date(date)).format('YYYY-MM-DD');
};
